import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="data-exports--run"
export default class extends Controller {
  static targets = ["definitionSelect", "format", "encoding", "modal", "modalDefName", "modalBody"]
  static values = { definitions: Array }

  // Uppercase display labels for the lowercase enum values.
  static DISPLAY = { sum: "SUM", count: "COUNT", avg: "AVG", max: "MAX", min: "MIN", asc: "ASC", desc: "DESC" }

  connect() {
    this.syncDefinition()
  }

  // On pattern change, snap the 出力形式 / 文字コード selects to the selected
  // pattern's stored defaults.
  syncDefinition() {
    const def = this.currentDefinition()
    if (!def) return

    if (this.hasFormatTarget && def.output_format) this.formatTarget.value = def.output_format
    if (this.hasEncodingTarget && def.character_code) this.encodingTarget.value = def.character_code
  }

  currentDefinition() {
    const code = this.hasDefinitionSelectTarget ? this.definitionSelectTarget.value : null
    return this.definitionsValue.find((d) => d.code === code)
  }

  openModal() {
    const def = this.currentDefinition()
    if (!def) {
      window.alert("出力定義を選択してください。")
      return
    }

    this.modalDefNameTarget.textContent = `${def.code}：${def.name}`
    this.modalBodyTarget.innerHTML = this.modalTableHtml(def)
    this.modalTarget.classList.remove("hidden")
  }

  closeModal() {
    this.modalTarget.classList.add("hidden")
  }

  backdropClose(event) {
    if (event.target === this.modalTarget) this.closeModal()
  }

  modalTableHtml(def) {
    const display = this.constructor.DISPLAY
    const columns = [...def.columns].sort((a, b) => a.sort_index - b.sort_index)
    const rows = columns
      .map((c) => {
        const settings = [
          c.grouped ? '<span class="pill group">GROUP</span>' : "",
          c.aggregated ? `<span class="pill sum">${display[c.aggregate_method] || "集計"}</span>` : "",
          c.sort_direction ? `<span class="pill sort">${display[c.sort_direction]}</span>` : ""
        ].join(" ")

        return `<tr>
          <td>${c.sort_index}</td>
          <td title="${c.name}">${c.name}</td>
          <td title="${c.display_name}">${c.display_name}</td>
          <td>${settings}</td>
        </tr>`
      })
      .join("")

    return `
      <div class="modal-table-wrap">
        <table class="modal-items-table">
          <thead>
            <tr>
              <th style="width:48px">順</th>
              <th>項目</th>
              <th>見出し名</th>
              <th style="width:150px">設定</th>
            </tr>
          </thead>
          <tbody>${rows}</tbody>
        </table>
      </div>`
  }
}
